import { render, staticRenderFns } from "./PolicyCoinsuranceServiceFee.vue?vue&type=template&id=5cf41bdc&"
import script from "./PolicyCoinsuranceServiceFee.vue?vue&type=script&lang=js&"
export * from "./PolicyCoinsuranceServiceFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports